<div class="quiz-end-container">
    <div class="quiz-end-falling-stars-container">
    <h1 *ngIf="!levelManagerService.isLevelUp">{{ 'quizEnd.text1' | translate}}</h1>
    <h1 *ngIf="levelManagerService.isLevelUp">{{ 'quizEnd.text2' | translate}}</h1>
    <h3 *ngIf="levelManagerService.isLevelUp" [innerHTML]="'quizEnd.text3' | translate: { value: levelManagerService.newReadingLevel}"></h3>
    <!-- <img src="../../assets/icons/falling-stars-animation.gif"/> -->
    <div [innerHTML]="safeAvatarSVG" class="end-page-avatar-svg-container"></div>
    <!-- <img src="../../../../assets/imgs/star_icon.png" class="quiz-finish-image"/> -->
    <h3 [innerHTML]="'quizEnd.text4' | translate: { value: levelManagerService.expPointsGained}"></h3>
    <h4 [innerHTML]="'quizEnd.text5' | translate: { value: levelManagerService.expPointsRequiredForNextLevel}"></h4>
    </div>
    <progress-bar [progress]="levelManagerService.levelProgressBarValue" [color]="'#6155A1'">
    </progress-bar>
    <div class="btn-container">
        <button class="btn btn-secondary" (click)="replayQuiz()">{{ 'quizEnd.text6' | translate}}</button>
        <button class="btn btn-secondary" (click)="backToHome()">
            <mat-icon>home</mat-icon> {{ 'quizEnd.text7' | translate}}
        </button>
    </div>
</div>
<!-- <script src="https://code.responsivevoice.org/responsivevoice.js?key=e5dGgiAW"></script> -->
